import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NullAsDefault} from 'views/Shared'
import {getId, getType} from "../../../../apis/model/base";
import {showDeleteConfirmDialog} from "../../factory/createConfirmDialog";
import {Modal} from "antd";
import LoadingBlock from "../../../LoadingBlock";
import _ from "lodash";
import {product_getById_Api} from "../../../../apis";
import useProductActions from "./useProductActions";
import {ProductVariantFormCreate, ProductVariantFormEdit} from "../components/ProductVariantForm";

export const useProductVariantForm = ({
                                          product,
                                          autoRefresh = true,
                                      }) => {
    const t = useTranslate()
    const [refreshKey, setRefreshKey] = useState()
    const [localProduct, setLocalProduct] = useState(product)
    const onError = notifyOnError(t)
    const onRefresh = () => {
        if (autoRefresh) {
            setRefreshKey(Date.now())
        }
    }
    const owner_type = getType(product);
    const owner_id = getId(product);

    const {handleAsyncAction: getProductById} = useAsyncAction({
        apiInfo: product_getById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setLocalProduct(dataItem);
        },
    })

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const fetchProductOnSuccess = () => {
        onCancel()
        getProductById({}, {id: product?.id})
    }

    const {
        addVariant,
        editVariantInfo,
        deleteVariant
    } = useProductActions({
        notifyListeners: {
            onCancel: onCancel,
            onRefresh: fetchProductOnSuccess,
        }
    })

    const confirmDeleteVariant = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete product variant',
                message: 'are you sure you want to delete this product variant',
                onOk: () => {
                    deleteVariant({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        const id = getId(params)
        switch (action) {
            case "VARIANT_CREATE":
            case "VARIANT_UPDATE":
                setAction({type: action, value: params})
                break
            case "VARIANT_DELETE":
                confirmDeleteVariant(id)
                break
            default:
                break
        }
    }

    const modal = useMemo(() => {
        if (!!!action?.type) return null;
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        const id = getId(action?.value)
        switch (action?.type) {
            case "VARIANT_CREATE":
                Component = ProductVariantFormCreate
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create product variant')}
                        </div>
                    ),
                }
                params = {
                    product,
                    onSubmit: (values) => {
                        addVariant(values, {id: product?.id})
                    },
                }
                break
            case "VARIANT_UPDATE":
                Component = ProductVariantFormEdit
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit product variant')}
                        </div>
                    ),
                }
                params = {
                    owner_type,
                    owner_id,
                    initialValues: action?.value,
                    onSubmit: (values) => {
                        editVariantInfo(values, {id})
                    },
                }
                break
            default:
                break
        }
        return (
            <Modal
                width={720}
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Component
                                {...params}
                                {...{item, onCancel}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, product?.id])

    return {
        modal,
        onCancel,
        handleAction,
        refreshKey,

        addVariant,
        editVariantInfo,
        deleteVariant
    }
}
